import { Box, Button, DialogActions, DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useCustomStyles } from '../../hooks';
import ResponsiveDialog from '../UI/Dialogs/ResponsiveDialog';
import Loader from '../Loaders/Loader';
import Dropzone from './Dropzone';

interface DropzoneDialogProps {
    open: boolean;
    multiple: boolean;
    accept: string;
    dialogTitle: string;
    onClose: () => void;
    onUpload: (files: File[]) => void;
    uploadedFiles: File[];
    onUploadedFilesChange: (files: File[]) => void;
    loading?: boolean;
    description?: React.ReactNode;
}

const DropzoneDialog: React.FC<DropzoneDialogProps> = ({
    open,
    multiple,
    accept,
    dialogTitle,
    onClose,
    onUpload,
    uploadedFiles,
    onUploadedFilesChange,
    loading,
    description,
}) => {
    const { t } = useTranslation();
    const classes = useCustomStyles();

    const handleFileUpload = () => {
        onUpload(uploadedFiles);
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <ResponsiveDialog
            fullScreen={false}
            fullWidth={true}
            title={dialogTitle}
            onClose={handleClose}
            open={open}
            actionButtons={
                <DialogActions sx={{ ...classes.dialogActions, ...classes.marginBottom }}>
                    <Button onClick={handleClose} variant="outlined">
                        {t('action.cancel')}
                    </Button>
                    <Button
                        onClick={handleFileUpload}
                        variant="contained"
                        disabled={loading || uploadedFiles.length === 0}
                    >
                        {t('action.upload')}
                    </Button>
                </DialogActions>
            }
        >
            <DialogContent sx={{ padding: 0 }}>
                {description && <Box sx={{ px: 3, pt: 2 }}>{description}</Box>}
                {loading ? (
                    <Box component="div" minHeight={'250px'} position={'relative'}>
                        <Loader style={{ top: '20%' }} />
                    </Box>
                ) : (
                    <Dropzone
                        uploadedFiles={uploadedFiles}
                        accept={accept}
                        multiple={multiple}
                        maxSizeInMB={100}
                        onFileUpload={onUploadedFilesChange}
                    />
                )}
            </DialogContent>
        </ResponsiveDialog>
    );
};

export default DropzoneDialog;
